import { Root as TabsRoot } from '@radix-ui/react-tabs'
import React from 'react'

interface TabbedFiltersProps {
  children: React.ReactNode
  defaultTab: string
}

export function TabbedFilters ({ children, defaultTab }: TabbedFiltersProps) {
  return (
    <TabsRoot
      // Note: We can't use automatic activation mode until this bug is fixed:
      // https://github.com/radix-ui/primitives/issues/1047
      activationMode='manual'
      className='grid'
      defaultValue={defaultTab}
      orientation='vertical'
    >
      {children}
    </TabsRoot>
  )
}

TabbedFilters.displayName = 'FiltersDropdown.TabbedFilters'
